var e={71:"New",131:"Clearance",127:"Premium Frames"},r=function(r){if(!r)return"";if(r.product_badge&&r.product_badge.length){var a=r.product_badge[0];return e[a]||""}if(r.badges&&r.badges.length){a=r.badges[0];return e[a.id]||""}return""};export{e as BADGES,r as getBadge};
//# sourceMappingURL=getBadge.js.map
